import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = null;
  }
  /*
  static getDerivedStateFromError(error) {
    console.log('tratando erro 1');
    toast.error(error);
    return null;
  }

  componentDidCatch(error, errorInfo) {
    console.log('tratando erro 2');
    toast.error(error);
    toast.error(errorInfo);
  }
  */

  render() {
    return this.props.children;
  }
}
